/* Global davranışlar: hareket yardımcıları, wishlist, AJAX sepete ekle, sepet sayacı, scroll reveal */
(function () {
  'use strict';

  var CAR_TWEEN_MS = 620;
  var FLY_MS = 720;
  var TOAST_MS = 3200;

  /* ---------- Hareket yardımcıları ---------- */
  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function easeOutQuint(t) {
    return 1 - Math.pow(1 - t, 5);
  }

  /**
   * Yatay kaydırmayı rAF ile tween'ler. Native scroll-behavior:smooth tarayıcıya
   * göre farklı ve çok kısa sürüyor; buradaki eğri her yerde aynı hissi verir.
   * scroll-snap tween sırasında kapatılır, yoksa her karede geri çekiyor.
   */
  function tweenScrollLeft(el, target, duration) {
    if (!el) return;
    var max = el.scrollWidth - el.clientWidth;
    var to = Math.max(0, Math.min(target, max));
    if (prefersReduced()) {
      el.scrollLeft = to;
      updateCarEdges(el);
      return;
    }
    var from = el.scrollLeft;
    var delta = to - from;
    if (Math.abs(delta) < 1) return;

    // Üst üste binen tween'de snap değerini bir kez sakla, yoksa 'none' kalıcı olur
    if (el.nnRaf) cancelAnimationFrame(el.nnRaf);
    if (typeof el.nnPrevSnap !== 'string') el.nnPrevSnap = el.style.scrollSnapType;
    el.style.scrollSnapType = 'none';
    el.classList.add('is-gliding');
    var startTime = null;
    var total = duration || CAR_TWEEN_MS;

    function step(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / total, 1);
      el.scrollLeft = from + delta * easeOutQuint(progress);
      if (progress < 1) {
        el.nnRaf = requestAnimationFrame(step);
      } else {
        el.nnRaf = null;
        el.style.scrollSnapType = el.nnPrevSnap;
        el.nnPrevSnap = null;
        el.classList.remove('is-gliding');
        updateCarEdges(el);
      }
    }
    el.nnRaf = requestAnimationFrame(step);
  }

  /* Kenar solma maskesi için başta/sonda mıyız bilgisini yaz */
  function updateCarEdges(track) {
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    track.classList.toggle('is-at-start', track.scrollLeft <= 2);
    track.classList.toggle('is-at-end', track.scrollLeft >= max - 2);
  }

  function initCarEdges() {
    document.querySelectorAll('.car').forEach(function (track) {
      updateCarEdges(track);
      if (track.dataset.edgeReady === 'true') return;
      track.dataset.edgeReady = 'true';
      track.addEventListener('scroll', function () {
        if (track.nnEdgeRaf) return;
        track.nnEdgeRaf = requestAnimationFrame(function () {
          track.nnEdgeRaf = null;
          updateCarEdges(track);
        });
      }, { passive: true });
    });
  }

  // Section inline script'leri bu yardımcıları kullanıyor.
  window.NNMotion = {
    scrollLeftTo: tweenScrollLeft,
    updateEdges: updateCarEdges,
    prefersReduced: prefersReduced,
    duration: CAR_TWEEN_MS
  };

  /* ---------- Wishlist (localStorage) ---------- */
  var WISH_KEY = 'nps_wishlist';

  function normalizeWishItem(raw) {
    if (typeof raw === 'string') return { url: raw };
    if (!raw || typeof raw !== 'object' || !raw.url) return null;
    return {
      url: String(raw.url).split('?')[0],
      title: raw.title ? String(raw.title) : '',
      image: raw.image ? String(raw.image) : '',
      price: raw.price ? String(raw.price) : ''
    };
  }

  function getWishlist() {
    try {
      var parsed = JSON.parse(localStorage.getItem(WISH_KEY)) || [];
      var seen = {};
      return parsed.map(normalizeWishItem).filter(function (item) {
        if (!item || seen[item.url]) return false;
        seen[item.url] = true;
        return true;
      });
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (e) {
      // Gizli mod veya dolu depolama favori butonlarını bozmamalı.
    }
  }

  function keyForCard(btn) {
    if (btn.dataset.wishUrl) return btn.dataset.wishUrl.split('?')[0];
    var card = btn.closest('.pcard');
    var link = card ? card.querySelector('a[href]') : null;
    if (link) return link.getAttribute('href').split('?')[0];
    return location.pathname;
  }

  function itemForButton(btn) {
    var card = btn.closest('.pcard');
    var title = btn.dataset.wishTitle;
    var image = btn.dataset.wishImage;
    var price = btn.dataset.wishPrice;

    if (!title && card) {
      var titleNode = card.querySelector('.pcard__title');
      title = titleNode ? titleNode.textContent.trim() : '';
    }
    if (!image && card) {
      var imageNode = card.querySelector('.pcard__img img');
      image = imageNode ? (imageNode.currentSrc || imageNode.src) : '';
    }
    if (!price && card) {
      var priceNode = card.querySelector('.pcard__price');
      price = priceNode ? priceNode.textContent.trim() : '';
    }

    if (!title) {
      var pageTitle = document.querySelector('h1');
      title = pageTitle ? pageTitle.textContent.trim() : document.title;
    }
    if (!image) {
      var ogImage = document.querySelector('meta[property="og:image"]');
      image = ogImage ? ogImage.content : '';
    }

    return {
      url: keyForCard(btn),
      title: title || 'Favori ürün',
      image: image || '',
      price: price || ''
    };
  }

  function hydrateWishlist(list) {
    var changed = false;
    document.querySelectorAll('.pcard__wish').forEach(function (btn) {
      var key = keyForCard(btn);
      var existing = list.find(function (item) { return item.url === key; });
      if (!existing) return;
      var details = itemForButton(btn);
      ['title', 'image', 'price'].forEach(function (field) {
        if (!existing[field] && details[field]) {
          existing[field] = details[field];
          changed = true;
        }
      });
    });
    if (changed) saveWishlist(list);
    return list;
  }

  function renderWishlist(list) {
    var count = list.length;
    var countLabel = document.getElementById('WishlistCount');
    var badge = document.querySelector('[data-wishlist-count]');
    var headingCount = document.querySelector('[data-wishlist-heading-count]');
    var items = document.querySelector('[data-wishlist-items]');
    var empty = document.querySelector('[data-wishlist-empty]');

    if (countLabel) countLabel.textContent = count ? 'Favoriler (' + count + ')' : 'Favoriler';
    if (badge) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
    }
    if (headingCount) headingCount.textContent = count + ' ürün';
    if (empty) empty.hidden = count > 0;
    if (!items) return;

    items.innerHTML = '';
    list.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'hdr__wishlist-item';

      if (item.image) {
        var image = document.createElement('img');
        image.className = 'hdr__wishlist-image';
        image.src = item.image;
        image.alt = '';
        image.width = 64;
        image.height = 64;
        image.loading = 'lazy';
        row.appendChild(image);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'hdr__wishlist-image hdr__wishlist-image--empty';
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.textContent = '♡';
        row.appendChild(placeholder);
      }

      var link = document.createElement('a');
      link.className = 'hdr__wishlist-info';
      link.href = item.url;

      var title = document.createElement('span');
      title.className = 'hdr__wishlist-title';
      title.textContent = item.title || 'Favori ürün';
      link.appendChild(title);

      if (item.price) {
        var price = document.createElement('span');
        price.className = 'hdr__wishlist-price';
        price.textContent = item.price;
        link.appendChild(price);
      }
      row.appendChild(link);

      var remove = document.createElement('button');
      remove.className = 'hdr__wishlist-remove';
      remove.type = 'button';
      remove.dataset.wishlistRemove = item.url;
      remove.setAttribute('aria-label', (item.title || 'Ürünü') + ' favorilerden kaldır');
      remove.textContent = '×';
      row.appendChild(remove);

      items.appendChild(row);
    });
  }

  function syncWishlist() {
    var list = hydrateWishlist(getWishlist());
    document.querySelectorAll('.pcard__wish').forEach(function (btn) {
      var active = list.some(function (item) { return item.url === keyForCard(btn); });
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Favorilerden kaldır' : 'Favorilere ekle');
    });
    renderWishlist(list);
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-wishlist-remove]');
    if (remove) {
      e.preventDefault();
      var filtered = getWishlist().filter(function (item) {
        return item.url !== remove.dataset.wishlistRemove;
      });
      saveWishlist(filtered);
      syncWishlist();
      return;
    }

    var btn = e.target.closest('.pcard__wish');
    if (!btn) return;
    e.preventDefault();
    var key = keyForCard(btn);
    var list = getWishlist();
    var index = list.findIndex(function (item) { return item.url === key; });
    if (index === -1) list.push(itemForButton(btn));
    else list.splice(index, 1);
    saveWishlist(list);
    syncWishlist();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === WISH_KEY) syncWishlist();
  });

  /* ---------- Sepet sayacı ---------- */
  function setCartCount(count) {
    var el = document.getElementById('CartCount');
    if (!el) return;
    el.textContent = count > 0 ? 'Sepet (' + count + ')' : 'Sepet';
    el.classList.remove('is-bumped');
    void el.offsetWidth; // reflow, animasyonu yeniden tetikler
    el.classList.add('is-bumped');
    setTimeout(function () { el.classList.remove('is-bumped'); }, 220);
  }

  /* ---------- Sepete eklendi geri bildirimi (ikon pulse + toast) ---------- */
  function pulseCartIcon() {
    var cartBtn = document.querySelector('.hdr__action--cart');
    if (!cartBtn) return;
    cartBtn.classList.remove('is-pulsing');
    void cartBtn.offsetWidth; // reflow, animasyonu yeniden tetikler
    cartBtn.classList.add('is-pulsing');
    cartBtn.addEventListener('animationend', function handler() {
      cartBtn.classList.remove('is-pulsing');
      cartBtn.removeEventListener('animationend', handler);
    });
  }

  var cartToastTimer;
  function showCartToast(message, isError) {
    var toast = document.getElementById('CartToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'CartToast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.className = 'cart-toast' + (isError ? ' cart-toast--error' : '');
    toast.innerHTML = '';

    var text = document.createElement('span');
    text.className = 'cart-toast__text';
    text.textContent = message;
    toast.appendChild(text);

    var icon = document.createElement('span');
    icon.className = 'cart-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = isError ? '!' : '✓';
    toast.insertBefore(icon, text);

    clearTimeout(cartToastTimer);
    toast.classList.remove('is-visible');
    void toast.offsetWidth; // reflow, giriş animasyonunu yeniden tetikler
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    cartToastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, TOAST_MS);
  }

  /* ---------- Ürün görselini sepete uçur ---------- */
  function flyToCart(sourceImg) {
    if (!sourceImg || prefersReduced() || typeof sourceImg.animate !== 'function') return;
    var cartBtn = document.querySelector('.hdr__action--cart');
    if (!cartBtn) return;

    var from = sourceImg.getBoundingClientRect();
    var to = cartBtn.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var ghost = document.createElement('img');
    ghost.src = sourceImg.currentSrc || sourceImg.src;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.className = 'nn-fly';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    document.body.appendChild(ghost);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    var animation = ghost.animate(
      [
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
        { transform: 'translate3d(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px,0) scale(0.55)', opacity: 0.9, offset: 0.55 },
        { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(0.12)', opacity: 0.15 }
      ],
      { duration: FLY_MS, easing: 'cubic-bezier(0.4, 0, 0.6, 1)', fill: 'forwards' }
    );
    animation.onfinish = function () { ghost.remove(); };
    animation.oncancel = function () { ghost.remove(); };
  }

  /* Sepete eklenen formun ürün görselini bul */
  function productImageFor(form) {
    var scope = form.closest('.pdp, .pdp__grid, main') || document;
    return scope.querySelector('.pdp__main-img img') || scope.querySelector('.pcard__img img');
  }

  function formatTry(cents) {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  /* ---------- AJAX sepete ekle ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (form.dataset.cartAdding === 'true') return;
    form.dataset.cartAdding = 'true';
    var sourceImg = productImageFor(form);
    if (btn) {
      btn.disabled = true;
      btn.classList.remove('is-done', 'is-error');
      btn.classList.add('is-loading');
      btn.textContent = 'Ekleniyor';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function (addedItem) {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          btn.textContent = '✓ Sepete Eklendi';
        }
        showCartToast('Ürün sepete eklendi', false);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: addedItem } }));
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Sepet bilgisi alınamadı');
            return response.json();
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            setCartCount(cart.item_count);
            pulseCartIcon();
          })
          .catch(function () {
            // The add succeeded; retry only the cart display without reporting a failed add.
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
          });
      })
      .catch(function (err) {
        var message = (err && err.description) ? err.description : 'Ürün sepete eklenemedi';
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          btn.textContent = 'Eklenemedi';
        }
        showCartToast(message, true);
      })
      .finally(function () {
        delete form.dataset.cartAdding;
        setTimeout(function () {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-loading', 'is-done', 'is-error');
            btn.innerHTML = original;
          }
        }, 2600);
      });
  });

  /* ---------- Scroll reveal ---------- */
  function initScrollReveal() {
    document.querySelectorAll('#MainContent .shopify-section > section, #MainContent .shopify-section > .wrap, #MainContent > .wrap, #MainContent .nn-equipment-finder').forEach(function (el) {
      if (!el.closest('.reveal') && !el.querySelector('.reveal')) el.classList.add('reveal');
    });
    var items = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!items.length) return;

    // Tema düzenleyicide veya IntersectionObserver desteklenmiyorsa direkt göster
    if (prefersReduced() || (window.Shopify && Shopify.designMode) || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -28px 0px' });

    // revealReady = "gözlemci bağlandı". theme.liquid'deki failsafe bu bayrağa bakar.
    items.forEach(function (el) {
      el.dataset.revealReady = 'true';
      observer.observe(el);
    });
  }

  function initAll() {
    syncWishlist();
    initScrollReveal();
    initCarEdges();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', function () {
    if (window.nnResizeTimer) clearTimeout(window.nnResizeTimer);
    window.nnResizeTimer = setTimeout(initCarEdges, 150);
  });
})();

